<template lang="pug">
div
  transition(name="slide-fade" mode="out-in")
    .app-drawer-holder(v-show="isBriqDrawerOpen")
      .app__drawer-content 
        .page-header 
          h2 {{ title }}
          .page-header__actions
            BriqButton(@click="closeBriqDrawer" small variant="dark") Close
        .page-description
          p.description.type-standard {{ description }}

        .page-content
          slot
  transition(name="slide-fade" mode="out-in")
    div(class="overlay" v-show="isBriqDrawerOpen" @click="closeBriqDrawer")
</template>
<script>
export default {
  name: 'BriqDrawer',
  props: {
    title: String,
    description: String,
    isBriqDrawerOpen: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    closeBriqDrawer() {
      this.$emit('closeBriqDrawer')
    },
  },
  created() {
    let that = this

    this.$document.addEventListener('keyup', function(evt) {
      if (evt.keyCode === 27) {
        that.closeBriqDrawer()
      }
    })
  },
}
</script>

<style scoped lang="stylus">
.app-drawer-holder
  position fixed
  top 0
  bottom 0
  width 443px
  height 100%
  right 0
  background #fff
  box-shadow 0 0 0px 0 rgba(0, 0, 0, 0.1)
  z-index 1000
  transform translateX(574px)
  transition transform 0.3s cubic-bezier(0.77, 0, 0.175, 1), box-shadow 0.6s
  overflow auto

  box-shadow 0 0 25px 0 rgba(0, 0, 0, 0.1)
  transform translateX(0)

  .app__drawer-content
    padding 40

    .page-header
      display flex
      align-items center
      justify-content space-between
      margin-bottom 20px

      h1.page-header__title
        flex 0 1 auto
        word-break break-word
        text-align left
        font-style normal
        font-family Roboto
        width: 300px;

      .page-header__actions
        flex 0 0 auto

    .page-description
      margin-bottom 20px

      .description
        font-family Roboto
        font-style normal
        font-weight normal
        text-align left

    .page-content
      text-align left

.overlay
  position fixed
  background-color transparent
  opacity 0.5
  width 100%
  height 100%
  top 0
  left 0
  z-index 99

.slide-fade-enter-active
  transition all 0.2s ease

.slide-fade-leave-active
  transition all 0.2s cubic-bezier(1.0, 0.5, 0.8, 1.0)

.slide-fade-enter, .slide-fade-leave-to
  transform translateX(700px)
  opacity 1
</style>
